export default {
  type: 'in_place',
  instanceName: 'client/smsSign',
  modalClassName: 'modal-sign-sms',

  fields: {
    password: { type: 'text' }
  }
};



// WEBPACK FOOTER //
// ./src/store/forms/formsConfigs/forms/smsCodeFormConfig.js